import { Table, TableHeader } from '@library/components/table';
import { Loading } from '@library/components/Loading';
import { MemberPollsRow } from '@bo-components/members/memberPolls/MemberPollsRow';
import { NoResults } from '@library/components/NoResults';
import { PaginationButtons } from '@library/components/buttons';
import { VOTES_TABLE_HEADER } from '@bo-constants/polls';
import { useMemberVotes } from '@bo-hooks/members/useMemberVotes';

export interface MemberPollsTableProps {
  memberUuid: string;
}
export const MemberPollsTable = ({ memberUuid }: MemberPollsTableProps) => {
  const {
    currentPage,
    onCurrentPageChange,
    isError,
    isLoading,
    memberVotes,
    totalPages
  } = useMemberVotes(memberUuid);

  if (isLoading && currentPage === 1) {
    return <Loading loadingMessage="" />;
  }

  if (isError) {
    return (
      <section className="p-6">
        <h1 className="text-soClean-100 m-auto text-xl font-bold">
          Error Fetching Member Polls
        </h1>
      </section>
    );
  }

  if (!memberVotes.length) {
    return (
      <NoResults
        className="m-0 w-full"
        dataTestId="no-member-polls"
        label="Current member does not have any polls"
        title="No Polls"
      />
    );
  }

  return (
    <section className="w-full px-6 pt-0">
      <Table className="border-soFresh-140 overflow-x-auto rounded-lg border p-0">
        <TableHeader headers={VOTES_TABLE_HEADER} />
        {memberVotes?.map((vote) => {
          const { id } = vote;
          return <MemberPollsRow vote={vote} key={id} />;
        })}

        <div className="bg-soFresh-100 border-soFresh-140 sticky bottom-0 flex w-full justify-end border-t">
          <div className="flex items-center justify-between">
            <PaginationButtons
              currentPage={currentPage}
              handlePageChange={onCurrentPageChange}
              totalPages={totalPages}
            />
          </div>
        </div>
      </Table>
    </section>
  );
};
